import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Collapse } from '@material-ui/core';

import classNames from 'classnames';
import _ from 'lodash';

import LabeledText from './LabeledText';

export type Props = {
  classes: any,
  className?: string,
  children: React.Node,
  title?: string | null,
  titleProps?: Object,
  label?: string,
  labelProps?: Object,
  icon?: any,
  collapseProps?: Object,
  expandButton?: boolean,
  expanded?: boolean,
  onExpand?: any => void
};

type State = {
  expanded: boolean
};

class ExpandingSection extends React.Component<Props, State> {
  state: State = {
    expanded:
      this.props.expanded !== null &&
      this.props.expanded !== undefined &&
      _.isBoolean(this.props.expanded)
        ? this.props.expanded
        : false
  };

  handleExpandClick = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  render() {
    const {
      children = <div />,
      classes,
      className,
      title,
      titleProps = {},
      label,
      labelProps = {},
      icon,
      expandButton = this.props.expandButton !== null &&
        this.props.expandButton !== undefined &&
        false,
      expanded: expandedProp,
      onExpand,
      collapseProps = {},
      ...otherProps
    } = this.props;

    const { expanded } = this.state;

    // allow controlled and non-controlled
    const _expanded: boolean =
      expandedProp !== undefined && _.isBoolean(expandedProp) ? expandedProp : expanded;
    let _onExpand: any => void =
      onExpand && _.isFunction(onExpand) ? onExpand : this.handleExpandClick;

    if (!expandButton) {
      _onExpand = () => {};
    }

    return (
      <div className={classNames(classes.root, className)} {...otherProps}>
        <LabeledText
          icon={icon}
          label={label}
          labelProps={labelProps}
          expandButton={expandButton}
          expanded={_expanded}
          onExpandClick={event => _onExpand(event)}
          {...titleProps}
        >
          {title || ''}
        </LabeledText>
        <Collapse
          className={classes.collapse}
          in={_expanded}
          timeout="auto"
          unmountOnExit
          {...collapseProps}
        >
          {children}
        </Collapse>
      </div>
    );
  }
}

const styles = ({
  spacing: { unit: spacing }
  //palette: { primary: primaryColorInfo }
}) => ({
  root: {
    width: '100%'
  },
  collapse: {
    width: '100%',
    paddingBottom: spacing * 1
  }
});

export default withStyles(styles)(ExpandingSection);
